"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleTierConfig = void 0;
exports.scaleTierConfig = {
    hasScaleTier: true,
};
